import classNames from 'classnames';
import styles from './Link.module.scss';
import { useRouteContext } from 'ui/contexts/RouteContext';

export interface LinkProps {
	children?: React.ReactNode;
	style?: 'sm';
	id?: string;
	className?: string;
	url: string;
	target?: string;
	title?: string;
	rel?: string;
	ariaControls?: string;
	ariaCurrent?: boolean;
	ariaExpanded?: boolean;
	ariaLabel?: string;
	clickHandler?: (event: React.MouseEvent) => void;
	disableRouteHandler?: boolean; // Set to true if you want to handle routing manually
	download?: boolean;
	locale?: string;
	withUnderline?: boolean;
}

export const UI_Link = ({
	children,
	style,
	id,
	className,
	url,
	target,
	title,
	rel,
	ariaControls,
	ariaCurrent,
	ariaExpanded,
	ariaLabel,
	clickHandler,
	disableRouteHandler,
	download,
	locale,
	withUnderline,
}: LinkProps) => {
	const { routeHandler } = useRouteContext() ?? {};
	return (
		<a
			id={id}
			className={classNames(styles.Link, styles[`Link___${style}`], { [styles.Link___withUnderLine]: withUnderline }, className)}
			href={url}
			target={target}
			title={title}
			rel={rel}
			onClick={(event) => {
				if (clickHandler) clickHandler(event);
				if (!disableRouteHandler && url && routeHandler) routeHandler(event, url, locale, target);
			}}
			aria-label={ariaLabel}
			aria-current={ariaCurrent ? 'page' : false}
			aria-expanded={ariaExpanded}
			aria-controls={ariaControls}
			download={download || undefined}
		>
			{children}
		</a>
	);
};
